import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { setupTextFilters } from "../../../../shared/helpers/filter-utils";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
})
export class InputComponent implements OnInit, OnChanges {
  @Input() placeholderText: string;
  @Input() controlName: string;
  @Input() width: string;
  @Input() selectedValue: any = "";
  @Output() inputValue = new EventEmitter();
  value: any;
  inputText = new FormControl("");
  isClear: boolean = false;

  constructor() {}

  ngOnInit(): void {
    const filterControls = [this.inputText];
    setupTextFilters(filterControls, () => this.onChange());
  }

  ngOnChanges(changes: SimpleChanges): void {
  if (
    changes["selectedValue"] &&
    changes["selectedValue"].currentValue !== undefined &&
    changes["selectedValue"].currentValue !== null &&
    changes["selectedValue"].currentValue !== this.inputText.value
  ) {
    this.inputText.setValue(
      changes["selectedValue"].currentValue,
      { emitEvent: false }
    );
  }
}

  onChange() {
    if (!this.isClear) {
      this.inputValue.emit(this.inputText.value);
    } else {
      this.isClear = false;
    }
  }

  clearField() {
    this.isClear = true;
    this.inputText.setValue("");
    this.inputValue.emit(this.inputText.value);
  }
}
